import React, { useState } from "react";

const CustomTabs = ({ tabs, defaultActiveKey, onChange }) => {
  const [activeTab, setActiveTab] = useState(defaultActiveKey);

  const handleTabClick = (key) => {
    setActiveTab(key);
    if (onChange) onChange(key);
  };

  return (
    <div className="">
      {/* Tabs Header */}
      <div className="flex border-gray-300 gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleTabClick(tab.key)}
            className={`py-2 px-4 border-2 border-[#E3B027]  rounded-[30px] h-[50px] w-[230px]  ${
              activeTab === tab.key ? "font-bold text-white bg-[#E3B027]" : "text-[#E3B027]"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tabs Content */}
      <div className="p-4">
        {tabs.map(
          (tab) =>
            activeTab === tab.key && (
              <div key={tab.key} className="animate-fadeIn">
                {tab.content}
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default CustomTabs;
